import PropTypes from 'prop-types';
import React from 'react';
import styles from './PoweredBy.scss';

class PoweredBy extends React.Component {
  render() {
    const {i18n} = this.props;
    /* eslint-disable no-template-curly-in-string */
    const poweredBy = i18n.get('openrest_order_confirmation_powered_by', 'Powered by ${link.begin}Wix Restaurants{link.end}', {
      link: {begin: '####', end: '####'}
    }).split('####');

    return (
      <div className={styles.poweredBy} data-hook="poweredby">
        <span>{poweredBy[0]}</span>
        <a className={styles.link} data-hook="poweredby-link" href="http://www.wix.com/restaurant/website">{poweredBy[1]}</a>
      </div>
    );
  }
}

PoweredBy.displayName = 'PoweredBy';
PoweredBy.propTypes = {
  i18n: PropTypes.object.isRequired
};

export default PoweredBy;



// WEBPACK FOOTER //
// ./components/PoweredBy/PoweredBy.js